import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components/icon/icon';

import { RadioButtonElement } from './radio-button-element';

interface RadioButtonGroupProps {
  elements: Array<{
    id?: string;
    title?: string;
    iconProps?: IconProps;
    active?: boolean;
    location?: 'start' | 'middle' | 'end';
    onClick?: () => void;
  }>;
  className?: string;
  elementClassName?: string;
  elementTypographyClassName?: string;
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = (props) => {
  const radioButtonGroupClassName = twMerge(
    'border border-solid border-gray200 rounded-md',
    'flex flex-row gap-0 items-start ',
    props.className,
  );

  return (
    <div className={radioButtonGroupClassName}>
      {props.elements.map((element) => {
        return (
          <RadioButtonElement
            key={element.id}
            {...element}
            className={props.elementClassName}
            typographyClassName={props.elementTypographyClassName}
          />
        );
      })}
    </div>
  );
};

export default RadioButtonGroup;
